export default () => ({
  entity: 'agenda',
  entities: 'agendas',
  prefixRouter: 'professional.agenda.agendas',
  agendas: [],
  errors: {},
  nextStepButtonsRules: [
    {
      icon: '',
      text: 'Incluir Regras',
      name: 'professional.agenda.rules.create',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/resources/data.js